
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class Dots extends Vue {
  @Prop() list
  @Prop({ default: 0 }) activeIndex: number

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
